/* eslint-disable camelcase */
import css from 'styled-jsx/css'

export default css`
  .sticky-header {
    position: fixed;
    width: 100%;
    max-width: 1920px;
    z-index: 999;
    transition: all 300ms ease-in-out;
  }

  .scroll-up .sticky-header {

  }

  .sticky-header.scroll-down {
    transform: translate3d(0, -100%, 0)
  }
`
